import React, { Component } from 'react';
import Loader from 'kepler/lib/components/Loader';
import Button from 'kepler/lib/components/Button';
import PropTypes from 'prop-types';
import getContent from '../lib/dictionaryFetcher';

class ErrorPanel extends Component {
  render() {
    const { errorMessage, onClick } = this.props;
    return (
      <div id="merchanthub-error-panel" className="merchanthub-error">
        <Loader
          status="warning"
          show={true}
          priority={10}
          opacity={0}
          size="lg"
        >
          <span className="merchanthub-error-desc">
            {getContent('merchanthub', 'errors.desc1', '')}
          </span>
          <span className="merchanthub-error-desc">
            {getContent('merchanthub', 'errors.desc2', '')}
          </span>
          <Button className="merchanthub-error-btn" onClick={onClick}>
            {getContent('merchanthub', errorMessage, '')}
          </Button>
        </Loader>
      </div>
    );
  }
}

function defaultClick() {
  location.reload();
}

ErrorPanel.propTypes = {
  errorMessage: PropTypes.string,
  onClick: PropTypes.func,
  tracking: PropTypes.func,
  recordImpression: PropTypes.func,
  app: PropTypes.object
};

ErrorPanel.defaultProps = {
  onClick: defaultClick,
  errorMessage: 'errors.tryAgain'
};
export default ErrorPanel;
